/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Options_Cli_Select_LocationInputs */



/**
* | output |
* | --- |
* | "Select {tool} location" |
*
* @param {Options_Cli_Select_LocationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_select_location = /** @type {((inputs: Options_Cli_Select_LocationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Select_LocationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Sélectionner l'emplacement de ${i?.tool}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Standort ${i?.tool} auswählen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Seleziona la posizione ${i?.tool}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Выберите местоположение ${i?.tool}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Seleccione la ubicación ${i?.tool}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`选择 ${i?.tool} 位置`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.tool} の場所を選択`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.tool} स्थान का चयन करें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Selecione a localização ${i?.tool}`)
	return /** @type {LocalizedString} */ (`Select ${i?.tool} location`)
});